// #region Actions
const actions = {
  async toggleSidebar({commit}, openSidebar) {
    commit('toggleSidebar', openSidebar);
  },
  async openMenu({commit}, {menuInfo}) {
    commit('openMenu', {menuInfo});
  },
};
// #endregion

// #region Getters
// #endregion

// #region Mutations
const mutations = {
  toggleSidebar(state, openSidebar) {
    const newTrigger = {
      trigger: Math.random() * 1, // Set trigger
      openSidebar,
    };
    state.triggerSidebar = newTrigger;
  },
  openMenu(state, {menuInfo}) {
    const newTrigger = {
      trigger: Math.random() * 1, // Set trigger
      menuInfo,
    };
    state.triggerMenu = newTrigger;
  },
};
// #endregion

// #region State
const state = () => {
  return {
    triggerMenu: null,
    triggerSidebar: null,
  };
};
// #endregion


// #region Etc
const namespaced = true;
const modules = []; // Submodules
// #endregion


export default {
  actions,
  // getters,
  modules,
  mutations,
  namespaced,
  state,
};
